import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { ClientsFetchAPI } from '../../../api/Clients';
import LoadingAlert from '../../Alerts/LoadingAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';
import Select from 'react-select';
import PhoneInput from 'react-phone-input-2'
import Maps from '../../../utils/Maps';
import AlertSmall from '../../Alerts/AlertSmall';
import { useTranslation } from 'react-i18next';
const ModalCreateAddressClient = ({ modalcreateAddressClient, setModalcreateAddressClient, getAddressClientNow, handleSelectAddress }) => {
    const { t } = useTranslation();
    const [modalUserRegister, setModalUserRegister] = useState(false)
    const [nameDirection, setNameDirection] = useState('')
    const [numberHouse, setNumberHouse] = useState('')
    const [phone, setPhone] = useState('')
    const [additional_info, setadditional_info] = useState('')
    const [tables, setTables] = useState([]);
    const [email, setEmail] = useState('')
    const [coordinates, setCoordinates] = useState({ lat: 0, lng: 0 });
    const [typeAddress, setTypeAddress] = useState("")

    let logo = ""
    if (localStorage.getItem('logo') != null || localStorage.getItem('logo') != undefined || localStorage.getItem('logo') != "") {
        logo = localStorage.getItem('logo')
    }


    let iconGeneral = ""
    if (localStorage.getItem('iconGeneral') != null || localStorage.getItem('iconGeneral') != undefined || localStorage.getItem('iconGeneral') != "") {
        logo = localStorage.getItem('iconGeneral')
    }


    const [clientInfo, setClientInfo] = useState(() => {
        if (localStorage.getItem('client') != null && localStorage.getItem('client') != undefined && localStorage.getItem('client') != '') {
            return JSON.parse(localStorage.getItem('client'))
        } else {
            return 0
        }
    })

    const [addressNowLocation, setAddressNowLocation] = useState(() => {
        if (localStorage.getItem('addressNowLocation') != null && localStorage.getItem('addressNowLocation') != undefined && localStorage.getItem('addressNowLocation') != '') {
            return JSON.parse(localStorage.getItem('addressNowLocation'))
        } else {
            return null
        }
    });

    const [guestClient, setGuestClient] = useState(() => {
        if (localStorage.getItem('guestClient') != null && localStorage.getItem('guestClient') != undefined && localStorage.getItem('guestClient') != '') {
            return localStorage.getItem('guestClient')
        } else {
            return null
        }
    });
    let token = undefined

    const cleanInputs = () => {
        setNameDirection('')
        setNumberHouse('')
        setPhone('')
        setadditional_info('')
        setModalcreateAddressClient(false)
    }

    const [fieldsError, setFieldsError] = useState({});

    const validateFields = () => {
        const missingFields = [];
        const errors = {};

        if (nameDirection.trim() === "") {
            missingFields.push(t('profile.modals.createAddress.fieldName'));
            errors.nameDirection = true;
        }
        if (numberHouse.trim() === "") {
            missingFields.push(t('profile.modals.createAddress.fieldHouseNum'));
            errors.numberHouse = true;
        }
        if (phone.trim() === "") {
            missingFields.push(t('profile.modals.createAddress.fieldPhone'));
            errors.phone = true;
        }
        if (additional_info.trim() === "") {
            missingFields.push(t('profile.modals.createAddress.fieldNotes'));
            errors.additional_info = true;
        }
        if (coordinates.lat === 0 || coordinates.lng === 0) {
            missingFields.push(t('profile.modals.createAddress.fieldLocation'));
            errors.coordinates = true;
        }

        setFieldsError(errors); // <-- Esto actualiza los inputs

        if (missingFields.length > 0) {
            AlertSmall(
                t('profile.modals.createAddress.missingFieldsPrefix', { fields: missingFields.join(", ") }),
                "warning"
            );
            return false;
        }
        return true;
    };

    const createAddressClient = async () => {
        if (!validateFields()) return;

        let data = {
            "name": nameDirection,
            "lat": coordinates.lat,
            "lng": coordinates.lng,
            "phone": phone,
            "house_num": numberHouse,
            "additional_info": additional_info,
            "email": email,
            "client_id": clientInfo?.id || clientInfo?.client_id || 0
        }

        if (guestClient === 0 || guestClient === "0") {
            try {
                const response = await ClientsFetchAPI.createAddressClient(data, token);
                ErrorAlert("", t('profile.modals.createAddress.createSuccess'), "success")
                getAddressClientNow()
                cleanInputs()

            } catch (err) {
                if (err.response.data.error && err.response.data.fields) {
                    // utils/handleApiError.js
                    const FIELD_MESSAGES = {
                        name: t('profile.modals.createAddress.nameEmptyError'),
                        phone: t('profile.modals.createAddress.phoneEmptyError'),
                        house_num: t('profile.modals.createAddress.houseNumEmptyError'),
                    };
                    //We determine wich field is empty
                    let fields = err.response.data.fields
                    fields.forEach(field => {
                        if (FIELD_MESSAGES[field]) {
                            ErrorAlert("", FIELD_MESSAGES[field], "warning")
                        }
                    });
                } else {
                    ErrorAlert("", t('profile.modals.createAddress.createError'), "error")
                }
            }
        } else {
            data.id = 0
            handleSelectAddress(data)
        }

    }


    const [step, setStep] = useState(1); // Estado para el paso actual
    const totalSteps = 2; // Número total de pasos

    const nextStep = () => {
        if (step < totalSteps) {
            if (step == 1) {
                if (coordinates.lat !== 0 && coordinates.lng !== 0) {
                    setStep(step + 1);
                } else {
                    AlertSmall(t('profile.modals.createAddress.clickMapWarning'), "warning")
                }
            } else {
                setStep(step + 1);
            }
        }
    };

    const prevStep = () => {
        if (step > 1) setStep(step - 1);
    };

    useEffect(() => {
        if (addressNowLocation) {
            if (addressNowLocation.id == 0) {
                setCoordinates({ lat: addressNowLocation.lat, lng: addressNowLocation.lng });
                setNameDirection(addressNowLocation.name)
                setPhone(addressNowLocation.phone)
                setadditional_info(addressNowLocation.additional_info)
                setNumberHouse(addressNowLocation.house_num)

            }
        }

    }, [addressNowLocation])



    return (
        <>
            <style>
                {`
      .border-danger {
        border-color: #dc3545 !important;
      }
    `}
            </style>
            <Modal
                show={modalcreateAddressClient}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >

                <Modal.Body className='bg-theme border rounded-3'>

                    <main className="dashboard-login-sp">
                        <div className='container login-container'>
                            <div className='row align-items-center'>
                                <div className="col-12 col-md-12 col-lg-12 col-xl-12 justify-content-center align-items-lg-center order-xxl-1 order-0">
                                    <div className="border-0 rounded-4">
                                        <div className=" p-0">
                                            <div className='main-login-sp mt-lg-1'>
                                                <section className="">
                                                    <div className="d-flex justify-content-between ">
                                                        <h2 className="text-theme h4">{t('profile.modals.createAddress.title')}</h2>
                                                        <button
                                                            type="button" onClick={() => (cleanInputs())}
                                                            className="btn btn-light btn-circle shadow-sm"
                                                            data-bs-dismiss="modal"
                                                            aria-label={t('common.close')}
                                                        >
                                                            <span aria-hidden="true">×</span>
                                                        </button>
                                                    </div>
                                                    <div>

                                                        <div className='row'>
                                                            <div className={`paso  col-12 col-xl-12 col-lg-12 col-md-12  position-relative ${step === 1 ? "activo" : ""}`}>
                                                                <div className='text-center w-100 rounded-2 mb-lg-2 '>
                                                                    <span className='d-flex justify-content-center p-0 mt-4 mt-lg-1  fw-bold h4'>
                                                                        {t('profile.modals.createAddress.step1')}
                                                                        <i className="uil uil-location-point"></i> {t('profile.modals.createAddress.step1Title')}
                                                                    </span>
                                                                </div>
                                                                <Maps modo="puntear-geolocator" position={setCoordinates} onClickCoordenada={coords => setCoordinates(coords)}
                                                                    logo={iconGeneral !== "" ? iconGeneral : logo} zoom={17} width={"100%"} height={"450px"} />

                                                            </div>

                                                            <div className={`paso  col-12 col-xl-12 col-lg-12 col-md-12  position-relative theme-blue ${step === 2 ? "activo" : ""}`}>
                                                                <div className=" d-flex align-items-start flex-column pt-2 card-payments-header-2 h-100">
                                                                    <div className='text-center w-100  top-card-header-terminales mb-lg-2  border-bottom'>
                                                                        <span className='d-flex justify-content-center p-0 mt-4 mt-lg-1  fw-bold h4'>
                                                                            {t('profile.modals.createAddress.step2')}
                                                                            <i className="uil uil-tablet"></i> {t('profile.modals.createAddress.step2Title')}
                                                                        </span>
                                                                    </div>
                                                                    <div className=' pb-4 row'>
                                                                        <div className='mt-lg-1 mt-1 col-12 text-end '>
                                                                            <small className='text-secondary'>{t('profile.modals.createAddress.requiredNote')}</small>
                                                                        </div>
                                                                        <div className="col-md-6 col-12 mt-4 mt-lg-0">
                                                                            <label className="form-label fw-bold text-black">
                                                                                <i class="uil uil-estate"></i> {t('profile.modals.createAddress.addressTypeLabel')}
                                                                            </label>
                                                                            <div className='m-3'>
                                                                                <input
                                                                                    type="radio"
                                                                                    className="btn-check "
                                                                                    name="btnradiotypeAddress"
                                                                                    id="btnradiotypeAddress1"
                                                                                    autoComplete="off"
                                                                                    onChange={(e) => (setNameDirection("Casa"), setTypeAddress("Casa"))}
                                                                                    checked={typeAddress === "Casa"}

                                                                                />
                                                                                <label className="btn btn-outline-primary border rounded-pill " htmlFor="btnradiotypeAddress1">
                                                                                    <small className='fw-bold mx-1'><i class="uil uil-estate"></i> {t('profile.modals.createAddress.home')}</small>
                                                                                </label>

                                                                                <input
                                                                                    type="radio"
                                                                                    className="btn-check "
                                                                                    name="btnradiotypeAddress"
                                                                                    id="btnradiotypeAddress2"
                                                                                    autoComplete="off"
                                                                                    onChange={(e) => (setNameDirection("Trabajo"), setTypeAddress("Trabajo"))}
                                                                                    checked={typeAddress === "Trabajo"}
                                                                                />
                                                                                <label className="btn btn-outline-primary border rounded-pill mx-1" htmlFor="btnradiotypeAddress2">
                                                                                    <small className='fw-bold mx-1'><i class="uil uil-constructor"></i> {t('profile.modals.createAddress.work')}</small>
                                                                                </label>
                                                                                <input
                                                                                    type="radio"
                                                                                    className="btn-check  "
                                                                                    name="btnradiotypeAddress"
                                                                                    id="btnradiotypeAddress3"
                                                                                    autoComplete="off"
                                                                                    onChange={(e) => (setTypeAddress("Otro"))}
                                                                                    checked={typeAddress === "Otro"}
                                                                                />
                                                                                <label className="btn btn-outline-primary border rounded-pill" htmlFor="btnradiotypeAddress3">
                                                                                    <small className='fw-bold mx-1'><i class="uil uil-archway"></i> {t('profile.modals.createAddress.other')}</small>
                                                                                </label>
                                                                            </div>
                                                                            {typeAddress === "Otro" && <input
                                                                                type={'text'}
                                                                                className="form-control rounded-3 border-1 text-muted"
                                                                                id="text"
                                                                                name='pass'
                                                                                placeholder={t('profile.modals.createAddress.addressNamePlaceholder')}
                                                                                required
                                                                                spellcheck="false" onChange={(e) => setNameDirection(e.target.value)}
                                                                            />}
                                                                        </div>

                                                                        <div className="mt-lg-2 mt-4 col-12 col-xl-6 col-lg-6 col-md-12">
                                                                            <label className="form-label fw-bold text-theme">
                                                                                <i className="uil uil-clinic-medical"></i> {t('profile.modals.createAddress.aptNumberLabel')}
                                                                            </label>
                                                                            <input
                                                                                type={'text'}
                                                                                className={`form-control rounded-3 border-1 text-muted ${fieldsError.numberHouse ? 'border-danger' : ''}`}
                                                                                value={numberHouse}
                                                                                id="numberHouse"
                                                                                name='house_num'
                                                                                placeholder="#45"
                                                                                required
                                                                                spellcheck="false" onChange={(e) => setNumberHouse(e.target.value)}
                                                                            />
                                                                        </div>

                                                                        {guestClient !== 0 || guestClient !== "0" ? <>
                                                                            <div className="mt-lg-2 mt-4 col-12 col-xl-6 col-lg-6 col-md-12">
                                                                                <label className="form-label fw-bold text-theme">
                                                                                    <i className="uil uil-fast-mail"></i> {t('profile.modals.createAddress.emailOptionalLabel')}
                                                                                </label>
                                                                                <input
                                                                                    type={'email'}
                                                                                    className={`form-control rounded-3 border-1 text-muted`}
                                                                                    value={email}
                                                                                    id="email"
                                                                                    name='email'
                                                                                    placeholder="example@exmaple.com"
                                                                                    spellcheck="false" onChange={(e) => setEmail(e.target.value)}
                                                                                />
                                                                            </div>
                                                                        </> : <></>}
                                                                        <div className="mt-lg-2 mt-4 col-12 col-xl-6 col-lg-6 col-md-12">
                                                                            <label className="form-label fw-bold text-theme ">
                                                                                <i className="uil uil-phone"></i> {t('profile.modals.createAddress.addressPhoneLabel')}
                                                                            </label>
                                                                            <PhoneInput
                                                                                country={'pa'}
                                                                                value={phone}
                                                                                onChange={phone => (setPhone(phone))}
                                                                                inputProps={{
                                                                                    name: 'phone',
                                                                                    required: true,
                                                                                    autoFocus: true,
                                                                                    className: `form-control rounded-3 border-1 text-muted ${fieldsError.phone ? 'border-danger' : ''}`,
                                                                                }}
                                                                                masks={{ pa: '.... ....' }} // Formato de 4 dígitos, espacio, 4 dígitos
                                                                                enableSearch
                                                                            />
                                                                        </div>

                                                                        {/* 
                                                                        <div className="mt-5 col-12">
                                                                            <label className="form-label fw-bold text-theme">
                                                                                <i className="uil uil-comment-notes"></i> Notas adicionales o referencias
                                                                            </label>
                                                                            <input
                                                                                type={'text'}
                                                                                className="form-control rounded-3 border-1 text-muted"
                                                                                id="text"
                                                                                name='pass'
                                                                                placeholder="Notas o referencias de la ubicacion"
                                                                                required
                                                                                spellcheck="false" onChange={(e) => setadditional_info(e.target.value)}
                                                                            />
                                                                        </div> */}
                                                                        <div className="mt-lg-5 mt-4 col-12">
                                                                            <label for="exampleFormControlTextarea1" className="form-label">
                                                                                <i className="uil uil-comment-notes"></i> {t('profile.modals.createAddress.notesLabel')}</label>
                                                                            <textarea
                                                                                className={`form-control rounded-3 border-1 text-muted ${fieldsError.additional_info ? 'border-danger' : ''}`}
                                                                                id="additional_info"
                                                                                value={additional_info}
                                                                                name='description'
                                                                                required
                                                                                placeholder={t('profile.modals.createAddress.notesPlaceholder')} rows="3"
                                                                                onChange={(e) => setadditional_info(e.target.value)}
                                                                            ></textarea>
                                                                        </div>


                                                                        <div className='d-flex justify-content-center align-items-center mt-4 flex-wrap'>
                                                                            {/*
                                                                            <button className={`m-1 btn btn-danger rounded btn-sm kiosk-subtitle-md position-relative px-5  mt-lg-2 mt-5  order-1 order-lg-0`} onClick={() => (cleanInputs())}>
                                                                                Cancelar
                                                                            </button> */}
                                                                            <button className="btn btn-add-product mt-lg-2  px-5 " onClick={() => createAddressClient()} >
                                                                                <span className='rotated-icon'>
                                                                                    <i className="uil uil-save me-2"></i>
                                                                                </span>
                                                                                {t('profile.modals.createAddress.saveAddress')}
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='d-block mt-lg-1 mt-0'>
                                                                <div className='d-flex justify-content-end'>
                                                                    <div className="botones-navegacion">
                                                                        {/* <button className='btn  btn-danger'
                                                                            disabled={step === totalSteps}>
                                                                            Cancelar
                                                                        </button> */}

                                                                        <button className='btn btn-secondary' onClick={prevStep} disabled={step === 1} type="button">
                                                                            {t('common.previous')}
                                                                        </button>

                                                                        <button className='btn btn-primary' onClick={nextStep} type="button" disabled={step === totalSteps} >
                                                                            {t('common.next')}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div >


                                                    </div>
                                                    {/* 
                                                    <footer >
                                                        <div className='container d-lg-flex justify-content-between align-content-center align-items-center w-100 text-center text-secondary'>
                                                            <div className=''>
                                                                <small className='opacity-50'>
                                                                    <i className="uil uil-copyright"></i> 2025 Smart Pay
                                                                </small>
                                                            </div>
                                                            <div>

                                                                <small className='opacity-50'>
                                                                    <i className="uil uil-bolt"></i> Powered by Smart Retail Group
                                                                </small>
                                                            </div>
                                                        </div>

                                                    </footer> */}
                                                </section>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>



                </Modal.Body >
            </Modal >

        </>
    )
}

export default ModalCreateAddressClient
